






import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import PremiumDisplay from '@/main-components/premium/PremiumDisplay.vue';
import { pageSEO } from '@/utils/seo';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    PremiumDisplay,
  },
  metaInfo(this: Pricing): MetaInfo {
    return {
      title: pageSEO.title.harga,
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: pageSEO.canonical.harga,
        },
      ],
      meta: [
        ...seoDefault({
          title: pageSEO.titleMeta.harga,
          description: pageSEO.description.harga,
        }),
      ],
    };
  },
})
export default class Pricing extends Vue {}
